import updateConversation from './updateConversation';

export default conversationId => (dispatch, _, { apiV2 }) => {
  dispatch(updateConversation.start());

  return apiV2
    .getConversation(conversationId, {
      expand: ['messages,advertiser,tenant,stateHistory'],
    })
    .then(({ data: conversation }) => {
      dispatch(updateConversation.done(conversation));
    })
    .catch(e => {
      dispatch(updateConversation.fail(e));
    });
};
